import { XemploLoader } from '@xemplo/loader';

import { useLogin } from './hooks/use-login';
import { LoginProps } from './auth-helper.types';

export function Login(props: LoginProps) {
  useLogin(props);
  return <XemploLoader />;
}
